import { Button, Form } from "react-bootstrap";
import parse from 'html-react-parser';
import { Faq } from "../../interfaces/Faq";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Overlay } from "../../elements/Overlay";

export interface FaqDeleteProps {
    faq: Faq;
    submitCallback: CallableFunction;
    closeCallback: CallableFunction;
}

export default function FaqDelete(props: FaqDeleteProps) {
    const { t } = useTranslation();

    const navigate = useNavigate();

    // Get title from default language translation or first available
    const defaultTranslation = props.faq.translations.find(trans => trans.lang === props.faq.defaultLang) || props.faq.translations[0];
    const faqTitle = defaultTranslation?.title || t("Untitled FAQ");

    const handleClose = () => {
        props.closeCallback();
    }

    const handleSubmit = (event: any) => {
        event.preventDefault();
        const requestOptionsDelete = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/faq/' + props.faq._id, requestOptionsDelete)
            .then(response => {
                props.submitCallback(props.faq._id);
            })
            .catch((error => {
                navigate('/');
            }));
    }

    return(
        <Overlay title={t("Delete FAQ")} onClose={handleClose} className="admin-delete-faq-container">
            <Form onSubmit={ handleSubmit }>
                <Form.Text id="deleteConfirmationMessage">
                    { parse(t("You are about to delete FAQ content") + ' ' + '<strong>' + faqTitle + '</strong>. ' +
                        t("This action cannot be undone.") + ' ' +
                        t("Are you sure you want to proceed?"))
                    }
                </Form.Text>
                <div className="actions">
                    <Button variant="primary" type="submit">{ t("Yes") }</Button>
                    <Button variant="secondary" onClick={ handleClose }>{ t("No") }</Button>
                </div>
            </Form>
        </Overlay>
    );
}